import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/esm/objectWithoutProperties";
import React from "react";
/**
 *
 * Label
 *
 */

/* eslint jsx-a11y/label-has-for: off */

var Label = function Label(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      formName = _ref.formName,
      htmlFor = _ref.htmlFor,
      extraProps = _objectWithoutProperties(_ref, ["ariaLabel", "children", "className", "formName", "htmlFor"]);

  return React.createElement("label", _extends({
    "aria-label": ariaLabel,
    className: className,
    form: formName,
    htmlFor: htmlFor
  }, extraProps), children);
};
/* istanbul ignore next */


Label.defaultProps = {
  ariaLabel: '',
  className: 'label',
  formName: ''
};
Label.displayName = 'Label';
export default Label;